export default __webpack_public_path__ + "static/media/04.25b43da6.svg";